// Pure game rules for جاسوس (Spy). No React, no I/O — just the deal.

// One spy keeps small groups tense; two spies stop big groups from
// trivially cornering a lone spy.
export function spyCountFor(playerCount) {
  return playerCount >= 7 ? 2 : 1
}

function shuffle(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

// Deal a round. Returns one assignment per player (aligned to the
// input `players` order):
//   { isSpy: true }                       — the spy/spies
//   { isSpy: false, roleIndex: number }   — role index into the
//                                            location's roles_* arrays
//
// roleIndex is locale-agnostic; the UI resolves it against
// location.roles_en / roles_ar. Roles are dealt without repeating
// until the pool is exhausted, then they wrap.
export function dealRound(playerCount, roleCount) {
  const spies = spyCountFor(playerCount)
  const spyIdx = new Set(shuffle([...Array(playerCount).keys()]).slice(0, spies))

  const roleOrder = roleCount > 0 ? shuffle([...Array(roleCount).keys()]) : []
  let nextRole = 0

  const assignments = []
  for (let i = 0; i < playerCount; i++) {
    if (spyIdx.has(i)) {
      assignments.push({ isSpy: true, roleIndex: null })
    } else {
      const roleIndex = roleCount > 0 ? roleOrder[nextRole % roleOrder.length] : null
      nextRole++
      assignments.push({ isSpy: false, roleIndex })
    }
  }
  return { assignments, spyCount: spies }
}

export const MIN_PLAYERS = 3
export const MAX_PLAYERS = 8
export const TIMER_OPTIONS = [5, 8, 10] // minutes

// Cool, universal names for computer players (read fine in any
// locale). Indexed by bot slot.
export const BOT_NAMES = ['Rex', 'Nova', 'Zero', 'Luna', 'Titan', 'Echo', 'Iris', 'Pixel']
export function botName(i) { return BOT_NAMES[i] || `Bot ${i + 1}` }
